import { Request } from '../../../index'

import {
  SubsidyOrdersSettingsApplyParams,
  SubsidyOrdersSettingsApplyResult,
} from 'app/common/types/food/schools/subsidyOrdersSettingsApply'

type ParamsDto = {
  /** Тип справки: cafeteria — индивидуальные справки на питание в школе; compensation — индивидуальные справки на питание с компенсацией родителю */
  order_type: 'cafeteria' | 'compensation'
  /** Категория льготы */
  allowance: string
}

type ResultDto = {
  result: 'success'
  running: boolean
}

type PathParamsDto = {
  id: string
}

export const convertParams = (
  params: SubsidyOrdersSettingsApplyParams,
): [ParamsDto, PathParamsDto] => {
  return [
    {
      order_type: params.orderType,
      allowance: params.allowance,
    },
    { id: params.id },
  ]
}

export const convertResult = (data: ResultDto): SubsidyOrdersSettingsApplyResult => {
  return { running: data.running }
}

export const POST_SCHOOL_SUBSIDY_ORDERS_SETTINGS_APPLY: Request<
  SubsidyOrdersSettingsApplyParams,
  SubsidyOrdersSettingsApplyResult,
  PathParamsDto
> = ['food/schools/{id}/subsidy_orders_settings_apply', 'post', ['data']]
